import axios from "axios";
import LinkService from '../src/services/LinkService';

const loggedIn = localStorage.getItem('userexam');
var user = JSON.parse(loggedIn);
if (user === null || user === undefined) {
  user = {
    accessToken: ''
  };
  
}
// console.log('accessToken',user.accessToken);

export default axios.create({
  baseURL: LinkService.getLink(),

  // baseURL : "https://api-test.ponnipa.in.th/api",

  headers: {
    "x-access-token": user.accessToken,
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET, POST',
    'Access-Control-Allow-Headers': 'Content-Type',
  },
  mode: 'no-cors'
});